console.log('[CPB] customproductbuilder.js loaded outside of func', new Date().toISOString());
(function () {
  console.log('[CPB] customproductbuilder.js loaded inside of func', new Date().toISOString());
  const CONTAINER_SELECTOR = '.cpb-panels-container';
  const PREVIEW_CONTAINER_SELECTOR = '.cpb-preview-container';
  const INNER_PREVIEW_SELECTOR = '.konvajs-content, canvas, img';

  const params = new URLSearchParams(window.location.search);
  const isEditMode = params.has('configid');

  if (isEditMode) {
    document.documentElement.classList.add('cpb-edit-mode');
  }

  // ────────────────────────────────────────────────
  // EDIT MODE — remove old line item
  // ────────────────────────────────────────────────
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
    if (!params.has('modifyProduct')) return;

    const keyId = params.get('modifyProduct');
    const addToCartBtn = document.querySelector('.cpb-add-to-cart-button');
    if (!addToCartBtn) return;

    const span = addToCartBtn.querySelector('span');
    if (span) span.textContent = 'Update Cart';

    addToCartBtn.addEventListener('click', () => {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: keyId, quantity: 0 })
      }).catch(() => {});
    });
  });

  // ────────────────────────────────────────────────
  // Zoom functionality (DISABLED < 1000px)
  // ────────────────────────────────────────────────
  let currentZoomIndex = -1;
  let currentActivePosition = null;

  function isMobileView() {
    return window.innerWidth < 1000;
  }

  function resetZoom() {
    const container = document.querySelector(PREVIEW_CONTAINER_SELECTOR);
    const inner = container ? container.querySelector(INNER_PREVIEW_SELECTOR) : null;
    if (!inner) return;
    inner.style.transition = '';
    inner.style.transform = '';
  }

  function applyZoom(stepIndex, position = null) {
    if (isMobileView()) {
      resetZoom();
      return;
    }

    const container = document.querySelector(PREVIEW_CONTAINER_SELECTOR);
    const inner = container ? container.querySelector(INNER_PREVIEW_SELECTOR) : null;
    if (!container || !inner) return;

    inner.style.transition = 'transform 0.4s ease-out';
    inner.style.transform = 'scale(1) translate(0, 0)';

    let scale = 1;
    let translateX = 0;
    let translateY = 0;

    if (stepIndex === 1) {
      scale = 2;
      translateY = 10;
    } else if (stepIndex === 2) {
      if (position !== null) {
        scale = 2;
        switch (position) {
          case 1:
            translateX = 20;
            translateY = -15;
            break;
          case 2:
            translateY = -35;
            break;
          case 3:
            translateX = -20;
            translateY = -15;
            break;
        }
      } else {
        scale = 1.3;
      }
    }

    if (scale > 1) {
      inner.style.transform = `scale(${scale}) translate(${translateX}%, ${translateY}%)`;
    }

    const panels = document.querySelector(CONTAINER_SELECTOR);
    if (panels) panels.style.paddingTop = '0px';
    container.style.marginBottom = '40px';
  }

  // ─── Tab change
  document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', (e) => {
    const idx = e.detail?.currentIndex;
    if (typeof idx === 'number') {
      setTimeout(() => {
        currentZoomIndex = idx;
        currentActivePosition = null;
        applyZoom(idx);
      }, 150);
    }
  });

  // ─── Position selection
  document.body.addEventListener('PRODUCT_BUILDER_OPTION_ACTIVATE', (e) => {
    if (currentZoomIndex !== 2) return;

    const title = e.detail?.category?.title?.toUpperCase() || '';
    let position = null;

    if (title.includes('POSITION 1')) position = 1;
    else if (title.includes('POSITION 2')) position = 2;
    else if (title.includes('POSITION 3')) position = 3;

    if (position !== null) {
      currentActivePosition = position;
      applyZoom(2, position);
    }
  });

  document.body.addEventListener('PRODUCT_BUILDER_OPTION_DEACTIVATE', () => {
    if (currentZoomIndex === 2) {
      currentActivePosition = null;
      applyZoom(2);
    }
  });

  document.body.addEventListener('CPB_ON_RENDER_LAYERS', () => {
    if (currentZoomIndex !== -1) {
      setTimeout(() => applyZoom(currentZoomIndex, currentActivePosition), 80);
    }
  });

  // ─── Resize handler
  window.addEventListener('resize', () => {
    if (isMobileView()) resetZoom();
    else if (currentZoomIndex !== -1) applyZoom(currentZoomIndex, currentActivePosition);
  });

  // ────────────────────────────────────────────────
  // Sticky control (native CSS)
  // ────────────────────────────────────────────────
  function initCPBStickyPreview() {
    const sticky = document.querySelector('.cpb-preview-sticky');
    if (!sticky) return;

    window.cpbStickyControl = {
      enable() { sticky.classList.add('cpb-sticky-active'); },
      disable() { sticky.classList.remove('cpb-sticky-active'); }
    };
  }

  document.addEventListener('DOMContentLoaded', initCPBStickyPreview);

  document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', (e) => {
    const idx = e.detail?.currentIndex;
    if (typeof idx !== 'number') return;

    if (idx === 2 && !isMobileView()) window.cpbStickyControl?.enable();
    else window.cpbStickyControl?.disable();
  });

  // ─── Force first tab
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
    setTimeout(() => {
      const firstTab = document.getElementById('react-tabs-0');
      if (firstTab) firstTab.click();
      currentZoomIndex = 0;
      applyZoom(0);
    }, 1200);
  });

 // ────────────────────────────────────────────────
// STICKY LOCK (robust):
// - while CPB makes preview-container fixed, we:
//   1) keep preview-elements scale >= MIN_SCALE
//   2) keep preview-layers height sane
//   3) add a spacer to prevent scroll jump caused by fixed positioning
// ────────────────────────────────────────────────
document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function () {
  if (window.innerWidth >= 1000) return;

  const productBuilder = document.querySelector('#product-builder');
  const previewContainer = document.querySelector('.cpb-preview-container');
  const panelContainer = document.querySelector('.cpb-panels-container');
  const previewLayers = document.querySelector('.cpb-preview-layers');

  if (!productBuilder || !previewContainer || !panelContainer || !previewLayers) return;

  const MIN_SCALE = 0.9;     // твой минимум
  const K_STICKY = 0.30;     // sticky top coef
  const K_PRE = 0.33;        // pre-sticky top coef
  const MIN_H = 320;
  const MAX_VH_K = 0.55;

  let raf = 0;
  let lastPadding = 0;

  function isStickyNow() {
    return getComputedStyle(previewContainer).position === 'fixed';
  }

  function parseMatrix(tr) {
    const m = tr && tr.match(/matrix\(([^)]+)\)/);
    if (!m) return null;
    const p = m[1].split(',').map(v => parseFloat(v.trim()));
    if (p.length !== 6 || p.some(n => Number.isNaN(n))) return null;
    return { a:p[0], b:p[1], c:p[2], d:p[3], e:p[4], f:p[5] };
  }

  function clampScaleIfSticky() {
    if (!isStickyNow()) return;

    const el = document.querySelector('.cpb-preview-elements');
    if (!el) return;

    const tr = getComputedStyle(el).transform;
    if (!tr || tr === 'none') return;

    const m = parseMatrix(tr);
    if (!m) return;

    if (m.a < MIN_SCALE || m.d < MIN_SCALE) {
      const na = Math.max(m.a, MIN_SCALE);
      const nd = Math.max(m.d, MIN_SCALE);
      const next = `matrix(${na}, ${m.b}, ${m.c}, ${nd}, ${m.e}, ${m.f})`;
      el.style.setProperty('transform', next, 'important');
    }
  }

  function getDesiredHeight() {
    const maxH = Math.round(window.innerHeight * MAX_VH_K);

    const konva = document.querySelector('.konvajs-content');
    const contentH = konva ? Math.round(konva.getBoundingClientRect().height) : 0;

    const contH = Math.round(
      previewContainer.getBoundingClientRect().height || previewContainer.clientHeight || 0
    );

    const base = Math.max(contentH, contH);
    return Math.max(MIN_H, Math.min(base, maxH));
  }

  function togglePreviewVisibility(paddingPx) {
    const rect = productBuilder.getBoundingClientRect();
    const completelyAbove = rect.bottom <= paddingPx;
    const completelyBelow = rect.top >= window.innerHeight;

    if (completelyAbove || completelyBelow) previewContainer.classList.add('hidden-preview');
    else previewContainer.classList.remove('hidden-preview');
  }

  function applyStickyRenderOffset(paddingPx) {
    const rw = document.querySelector('.cpb-render-wrapper');
    const konva = document.querySelector('.konvajs-content');
    if (!rw) return;

    if (!isStickyNow()) return; // sticky-only
    if (!konva) return;

    const contentH = Math.round(konva.getBoundingClientRect().height);
    const winH = paddingPx;

    const diff = Math.max(0, contentH - winH);
    const top = Math.round(-diff * K_STICKY);

    rw.style.setProperty('top', `${top}px`, 'important');
  }

  function applyPreStickyOffset() {
    const w = window.innerWidth;

    // только 700–999 и только ДО sticky
    if (w < 700 || w >= 1000) return;
    if (isStickyNow()) return;

    const rw = document.querySelector('.cpb-render-wrapper');
    const konva = document.querySelector('.konvajs-content');
    const layers = document.querySelector('.cpb-preview-layers');
    if (!rw || !konva || !layers) return;

    const contentH = Math.round(konva.getBoundingClientRect().height);
    const winH = Math.round(layers.getBoundingClientRect().height);

    if (contentH > winH) {
      const diff = contentH - winH;
      const top = Math.round(-diff * K_PRE);
      rw.style.setProperty('top', `${top}px`, 'important');
    } else {
      rw.style.removeProperty('top');
    }
  }

  function resetTopIfNeeded() {
    // если мы не в 700–999 и не sticky — лучше не держать top
    const rw = document.querySelector('.cpb-render-wrapper');
    if (!rw) return;

    const w = window.innerWidth;
    const inPreBand = w >= 700 && w < 1000;

    if (!isStickyNow() && !inPreBand) {
      rw.style.removeProperty('top');
    }

    if (isStickyNow() && inPreBand) {
      // в sticky top задаётся sticky функцией, pre-sticky не нужен
      // тут ничего
    }
  }

  function tick() {
    raf = 0;

    const paddingPx = getDesiredHeight();

    if (Math.abs(paddingPx - lastPadding) > 2) {
      panelContainer.style.setProperty('--padding', `${paddingPx}px`);
      previewLayers.style.setProperty('--padding', `${paddingPx}px`);
      lastPadding = paddingPx;
    }

    togglePreviewVisibility(lastPadding);

    // 1) до sticky — поднимаем в 700–999
    applyPreStickyOffset();

    // 2) sticky — поднимаем по формуле
    applyStickyRenderOffset(lastPadding);

    // 3) sticky — клампим scale (двойной проход против поздней записи CPB)
    clampScaleIfSticky();
    setTimeout(clampScaleIfSticky, 0);

    resetTopIfNeeded();
  }

  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(tick);
  }

  // старт
  schedule();
  setTimeout(schedule, 150);

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule);

  document.body.addEventListener('CPB_ON_RENDER_LAYERS', schedule);

  const mo = new MutationObserver(schedule);
  mo.observe(previewContainer, { attributes: true, attributeFilter: ['style', 'class'] });
});

})();